/**
 * Cross-browser, multi-device Fullscreen helper.
 * Supports modern standard Fullscreen API, WebKit prefix, and Safari iOS video element fallback.
 */

export const isFullscreenActive = () => {
  if (typeof document === 'undefined') return false;
  return !!(
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement
  );
};

export const requestFullscreen = async (containerEl, videoEl) => {
  if (typeof document === 'undefined') return false;

  // 1. Try container element first if supported (desktop browsers, Android)
  if (containerEl) {
    try {
      if (containerEl.requestFullscreen) {
        await containerEl.requestFullscreen();
        return true;
      }
      if (containerEl.webkitRequestFullscreen) {
        containerEl.webkitRequestFullscreen();
        return true;
      }
      if (containerEl.mozRequestFullScreen) {
        containerEl.mozRequestFullScreen();
        return true;
      }
      if (containerEl.msRequestFullscreen) {
        containerEl.msRequestFullscreen();
        return true;
      }
    } catch (err) {
      // Permission denied or not supported on this container, try video element
    }
  }

  // 2. Try video element directly
  const vid = videoEl || (containerEl && containerEl.querySelector ? containerEl.querySelector('video') : null);
  if (vid) {
    try {
      if (vid.requestFullscreen) {
        await vid.requestFullscreen();
        return true;
      }
      if (vid.webkitRequestFullscreen) {
        vid.webkitRequestFullscreen();
        return true;
      }
      // 3. Crucial for iOS / iPad Safari: webkitEnterFullscreen
      if (vid.webkitEnterFullscreen) {
        vid.webkitEnterFullscreen();
        return true;
      }
      if (vid.webkitEnterFullScreen) {
        vid.webkitEnterFullScreen();
        return true;
      }
      if (vid.mozRequestFullScreen) {
        vid.mozRequestFullScreen();
        return true;
      }
      if (vid.msRequestFullscreen) {
        vid.msRequestFullscreen();
        return true;
      }
    } catch (err) {
      console.error("Video fullscreen fallback failed:", err);
    }
  }

  return false;
};

export const exitFullscreen = async (videoEl) => {
  if (typeof document === 'undefined') return;

  try {
    if (document.exitFullscreen) {
      await document.exitFullscreen();
      return;
    }
    if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
      return;
    }
    if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
      return;
    }
    if (document.msExitFullscreen) {
      document.msExitFullscreen();
      return;
    }
  } catch (err) {}

  if (videoEl && videoEl.webkitExitFullscreen) {
    try {
      videoEl.webkitExitFullscreen();
    } catch (err) {}
  }
};
